import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";  // Import getAuth for authentication
import { getFirestore } from "firebase/firestore";  // Import Firestore for db
import { getStorage } from "firebase/storage";  // Optional, if you're using storage

const firebaseConfig = {
    apiKey: "AIzaSyBhb4e7-fFoi61ULFp8E5aFTJZNYfKZbno",
    authDomain: "aklo-optical.firebaseapp.com",
    projectId: "aklo-optical",
    storageBucket: "aklo-optical.firebasestorage.app",
    messagingSenderId: "164941920543",
    appId: "1:164941920543:web:89d1a6f16c2d27ca83d82a"
  };

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);  // Initialize Firebase Authentication
const db = getFirestore(app);  // Initialize Firestore
const storage = getStorage(app);  // Initialize Firebase Storage (if needed)

export { auth, db, storage };